import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEditorStateContext } from '../../context/notes/notes_editor_state_context';
import { Theme } from '../../styles';
export function PlaceholderText({ left, marginTop }) {
    const { displayModeYn, currentMarkdownInEditor, readOnlyYn } = useEditorStateContext();
    const show = !displayModeYn && !currentMarkdownInEditor && !readOnlyYn;
    return (_jsx(PlaceholderWrapper, { "data-testid": "type-note-placeholder", show: show, left: left, marginTop: marginTop, children: "Type a note" }));
}
const PlaceholderWrapper = function ({ show, left, marginTop, children, }) {
    // using div instead of a styled component to allow setting inert attribute
    const styles = {
        position: 'absolute',
        left,
        color: Theme.colors.grey60,
        pointerEvents: 'none',
        opacity: show ? 1 : 0,
        fontSize: Theme.text.size.medium,
        lineHeight: Theme.text.lineHeight.medium,
        marginTop,
    };
    return (
    // Inert is set to prevent this component from being focusable
    // @ts-expect-error: ts2322: inert is supported by most browsers, but not TS 4.9.5
    _jsx("div", { "data-testid": "type-note-placeholder", style: styles, inert: "", children: children }));
};
//# sourceMappingURL=placeholder_text.js.map